
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { IFilter } from '@/contract/search.contract';

@Component({})
export default class FilterTagContainer extends Vue {
  @Prop()
  public activeFilters!: Array<{ groupId: string, filter: IFilter}>;

  public get hasFilters(): boolean {
    return this.activeFilters?.length > 0;
  }
}
